export default {"src":"/_next/static/media/b7.d6412364.svg","height":65,"width":159,"blurWidth":0,"blurHeight":0};